export default __webpack_public_path__ + "static/media/Break an Egg_ Season the Meat.419834a2.png";